import { render } from "./soal_pilihan_ganda.vue?vue&type=template&id=5068f610&scoped=true"
import script from "./soal_pilihan_ganda.vue?vue&type=script&lang=js"
export * from "./soal_pilihan_ganda.vue?vue&type=script&lang=js"

import "./soal_pilihan_ganda.vue?vue&type=style&index=0&id=5068f610&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5068f610"]])

export default __exports__